import { ActionType, getType } from 'typesafe-actions'
import { IEntityHashMap } from 'flux-entities'

import * as actions from './actions'
import { ISSORealmsState, createInitialSSORealmsState } from './types'
import { TSSORealm } from '../../types/ssoRealm'

type TAction = ActionType<typeof actions>

const initialSSORealmsState = createInitialSSORealmsState()

const ssoRealmsReducer = (state = initialSSORealmsState, action: TAction): ISSORealmsState => {
  switch (action.type) {
    case getType(actions.ssoRealmsError): {
      return {
        ...state,
        errors: action.payload,
        touched: true,
        loading: false,
      }
    }

    case getType(actions.ssoRealmsRequest): {
      return {
        ...state,
        touched: true,
        loading: true,
      }
    }

    case getType(actions.ssoRealmsSuccess): {
      const all: IEntityHashMap<TSSORealm> = {}
      const ids: number[] = []

      for (const ssoRealm of action.payload) {
        if (!all[ssoRealm.id]) {
          ids.push(ssoRealm.id)
          all[ssoRealm.id] = ssoRealm
        }
      }

      return {
        all,
        ids,
        touched: true,
        loading: false,
        errors: [],
      }
    }

    case getType(actions.ssoRealmCreateError): {
      return {
        ...state,
        errors: action.payload,
        touched: true,
        loading: false,
      }
    }

    case getType(actions.ssoRealmCreateRequest): {
      return {
        ...state,
        touched: true,
        loading: true,
      }
    }

    case getType(actions.ssoRealmCreateSuccess): {
      return {
        ids: Array.from(new Set([...state.ids, action.payload.id])),
        all: {
          ...state.all,
          [action.payload.id]: action.payload,
        },
        touched: true,
        loading: false,
        errors: []
      }
    }

    case getType(actions.ssoRealmUpdateError): {
      return {
        ...state,
        errors: action.payload,
        touched: true,
        loading: false,
      }
    }

    case getType(actions.ssoRealmUpdateRequest): {
      return {
        ...state,
        touched: true,
        loading: true,
      }
    }

    case getType(actions.ssoRealmUpdateSuccess): {
      return {
        ...state,
        all: {
          ...state.all,
          [action.payload.id]: action.payload,
        },
        touched: true,
        loading: false,
        errors: []
      }
    }

    case getType(actions.ssoRealmDeleteError): {
      return {
        ...state,
        errors: action.payload,
        touched: true,
        loading: false,
      }
    }

    case getType(actions.ssoRealmDeleteRequest): {
      return {
        ...state,
        touched: true,
        loading: true,
      }
    }

    case getType(actions.ssoRealmDeleteSuccess): {
      const ids = state.ids.filter(x => x !== action.payload.id)
      const updatedState: IEntityHashMap<TSSORealm> = { ...state.all }
      delete updatedState[action.payload.id]

      return {
        ids,
        all: updatedState,
        touched: true,
        loading: false,
        errors: []
      }
    }
  }

  return state
}

export {
  ssoRealmsReducer,
  initialSSORealmsState
}
